import { Pagination } from '@/components/ui'

import { useQRCodePage } from '@/hooks/useQRCode/useQRCodePage'

import { QRCodeGenerateModal } from './QRCodeGenerateModal'
import { QRCodeHeader } from './QRCodeHeader'
import { QRCodeSearchBar } from './QRCodeSearchBar'
import { QRCodeCard } from './QRCodeCard'
import { QRCodeEmptyState } from './QRCodeEmptyState'

export function QRCode() {
  const {
    searchTerm,
    setSearchTerm,
    isModalOpen,
    setIsModalOpen,
    currentPage,
    setCurrentPage,
    qrCodes,
    totalPages,
    status,
    isDownloading,
    isDownloadingAll,
    isRegenerating,
    handleDownload,
    handleDownloadAll,
    handleReload,
    handleRegenerateTrolley,
    handleRegenerateErrors,
    isRegeneratingErrors,
    hasErrorCodes,
  } = useQRCodePage()

  return (
    <section className='p-5'>
      <QRCodeHeader
        onDownloadAll={handleDownloadAll}
        isDownloadingAll={isDownloadingAll}
        hasQRCodes={qrCodes.length > 0}
      />

      {(qrCodes.length > 0 || searchTerm.trim().length > 0) && (
        <QRCodeSearchBar
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          lastGeneratedAt={status?.last_generated_at}
          onRegenerateErrors={handleRegenerateErrors}
          isRegeneratingErrors={isRegeneratingErrors}
          showRegenerateErrors={hasErrorCodes}
        />
      )}

      {qrCodes.length > 0 ? (
        <>
          <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6'>
            {qrCodes.map(qr => (
              <QRCodeCard
                key={qr.trolley_id}
                trolleyId={qr.trolley_id}
                trolleyName={qr.trolley_name ?? ''}
                hasQrCode={!!qr.has_qr_code}
                qrCodeKey={qr.qr_code_key ?? ''}
                onDownload={handleDownload}
                onRegenerate={handleRegenerateTrolley}
                isDownloading={isDownloading}
                isDownloadingAll={isDownloadingAll}
              />
            ))}
          </div>

          {totalPages > 1 && (
            <div className='flex justify-end mt-6'>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>
          )}
        </>
      ) : (
        <QRCodeEmptyState />
      )}

      <QRCodeGenerateModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onReload={handleReload}
        isLoading={isRegenerating}
      />
    </section>
  )
}
